import { render, staticRenderFns } from "./Hot_wire.vue?vue&type=template&id=40d0a3fa"
import script from "./Hot_wire.vue?vue&type=script&lang=js"
export * from "./Hot_wire.vue?vue&type=script&lang=js"
import style0 from "./Hot_wire.vue?vue&type=style&index=0&id=40d0a3fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports